import { Link } from "react-router-dom";

import { convertToLocalDateTime, formatDate } from "components/helpers";
import {
  CustomFieldsPanelSection,
  PanelField,
  PanelSection,
} from "components/sidebar/sections/InfoPanel";
import TagsPanelSection from "components/sidebar/sections/TagsPanelSection";

// Read-only information for the campaign target detail rail; the tags belong to
// the linked entity, and the user's "Show disabled tags" preference governs
// which tags the dropdown and list show. Controls live in the header.
const CampaignTargetInfoPanel = ({
  campaignTarget,
  entity,
  showDisabledTags,
  onUpdate,
  isLoading = false,
  isEntityLoading = false,
}) => {
  const metrics = campaignTarget?.metrics ?? {};
  const statusUpdatedAt = campaignTarget?.status_last_updated_at;

  return (
    <>
      <PanelSection isLoading={isLoading}>
        <PanelField label="Entity Name">
          {campaignTarget?.entity_id ? (
            <Link to={`/entities/${campaignTarget.entity_id}`}>
              {campaignTarget.entity_name}
            </Link>
          ) : null}
        </PanelField>
        <PanelField label="Creator">
          {campaignTarget?.creator_user_full_name}
        </PanelField>
        <PanelField label="Assignee">
          {campaignTarget?.assigned_full_name}
        </PanelField>
        <PanelField label="Created at">
          {formatDate(campaignTarget?.created_at)}
        </PanelField>
        <PanelField label="Campaign Status">
          {campaignTarget?.campaign_status?.name}
        </PanelField>
        <PanelField label="Campaign Status Last Updated At">
          {statusUpdatedAt
            ? convertToLocalDateTime(statusUpdatedAt).format("YYYY-MM-DD")
            : "N/A"}
        </PanelField>
      </PanelSection>

      <PanelSection title="Metrics" isLoading={isLoading}>
        <PanelField label="Contacts">{metrics.contact_count}</PanelField>
        <PanelField label="Contacts in Campaign">
          {metrics.campaign_contact_count}
        </PanelField>
        <PanelField label="Emailable Contacts">
          {metrics.emailable_contact_count}
        </PanelField>
        <PanelField label="Callable Contacts">
          {metrics.callable_contact_count}
        </PanelField>
      </PanelSection>

      <TagsPanelSection
        title="Tags"
        modelType="Entity"
        record={entity}
        isLoading={isEntityLoading}
        showDisabledTags={showDisabledTags}
        onUpdate={onUpdate}
      />

      <CustomFieldsPanelSection
        title="Campaign Target Custom Fields"
        items={campaignTarget?.custom_fields}
        modelType="CampaignTarget"
        isLoading={isLoading}
      />

      <CustomFieldsPanelSection
        title="Entity Custom Fields"
        items={entity?.custom_fields}
        modelType="Entity"
        isLoading={isEntityLoading}
      />
    </>
  );
};

export default CampaignTargetInfoPanel;
